module.exports = __webpack_public_path__ + "img/thumb_22.c21dfe35.jpg";